import React from "react";
import { GearIcon, MailIcon } from "./icons";

export default function TabBar({ activeTab, onTabChange }) {
  return (
    <nav className="tab-bar">
      <button
        className={`tab-btn${activeTab === "file" ? " active" : ""}`}
        onClick={() => onTabChange("file")}
        type="button"
      >
        <MailIcon />
        File Email
      </button>
      <button
        className={`tab-btn${activeTab === "settings" ? " active" : ""}`}
        onClick={() => onTabChange("settings")}
        type="button"
      >
        <GearIcon />
        Settings
      </button>
    </nav>
  );
}
